import { render } from "./oap-beauty-option.vue?vue&type=template&id=5740681b"
import script from "./oap-beauty-option.vue?vue&type=script&lang=js"
export * from "./oap-beauty-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__